<template>

    <div class="content-slider">

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Testimonial Slider</h2>
        <ul class="testimonialslider-selection-style">
            <li :class="settingsFromWeebly.settings.testimonialStyle === 'style1' ? 'active': null" @click="settingsFromWeebly.settings.testimonialStyle = 'style1'">Style 1</li>
            <li :class="settingsFromWeebly.settings.testimonialStyle === 'style2' ? 'active': null" @click="settingsFromWeebly.settings.testimonialStyle = 'style2'">Style 2</li>
        </ul>

        <ul class="slider-actions">
            <li v-if="settingsFromWeebly.settings.slideReordering" @click="addToChildArray" class="add-slide-btn" v-b-tooltip.hover.top title="New slide will be appended at the end of the slider">
                +
            </li>
            <li v-if="!settingsFromWeebly.settings.slideReordering" @click="reOrderSlides" class="reorder-slides-btn" v-b-tooltip.hover.top title="Click to style, re-arrange or delete slides.">
                manage slides
                <i class="fas fa-wrench"></i>
            </li>
            <li v-if="settingsFromWeebly.settings.slideReordering" @click="reloadFlickity" class="reactivate-slider-btn" v-b-tooltip.hover.top title="Click to re-activate after your slides were re-arranged.">
                activate slider
                <i class="fas fa-sync-alt"></i>
            </li>
        </ul>



        <div class="preview-box" :style="{width : previewBoxWidth}">

            <draggable 

                v-model="slidesArray" 
                ghost-class="ghost-block" 
                handle=".block-drag-handle"

                class="bundle-content-slider bundle-slider bundle-testimonial-slider" 
                :class="[
                (settingsFromWeebly.settings.testimonialStyle === 'style1' ? 'bundle-testimonial-slider-style1': null),
                (settingsFromWeebly.settings.testimonialStyle === 'style2' ? 'bundle-testimonial-slider-style2': null)
                ]"
                :id="'bundle-content-slider-'+globalSettings.elementIdWeebly"

                :data-loop="settingsFromWeebly.settings.loop"
                :data-autoplay="settingsFromWeebly.settings.autoplay"
                :data-autoplayspeed="settingsFromWeebly.settings.autoplaySpeed"
                >

                <TestimonialSliderSlide 
                    v-for="(slide, index) in slidesArray" :key="index"
                    :slideId="slide.slideId"
                    :slideIndex="index"
                    :slide="slide"
                    class="bundle-content-slider--slide" 
                    :class="[
                    (slide.slideAnimation ? slide.animationClass : null)
                    ]"
                    :id="slide.slideId"
                />

            </draggable> 

            <component :is="style">
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider {

                }

                .bundle-slider {
                    position: relative;
                    overflow: hidden;
                }
                .bundle-slider, .bundle-slider:focus, .bundle-slider:active {
                    outline: none;
                }
                .bundle-content-slider--slide {
                    width: 100%;
                    min-height: 100%;
                    overflow: hidden;
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider.bundle-partial-slider .bundle-content-slider--slide{
                    width: calc(100% - 150px);
                    {{ settingsFromWeebly.settings.useSpacing ? 'margin-right: '+settingsFromWeebly.settings.spaceBetween+'px;': null}}
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .bundle-content-slider--slide-inner {
                    min-height: {{settingsFromWeebly.settings.minHeight}}px;
                } 




                .bundle-slide-animation-slideInTop .bundle-content-slider--slide-inner {
                    opacity: 0;
                    transform: translateY(-100%);
                    transition: all .6s ease-out .5s;
                }
                .bundle-content-slider--slide.is-selected.bundle-slide-animation-slideInTop  .bundle-content-slider--slide-inner {
                    opacity: 1;
                    transform: translateY(0);
                }

                .bundle-slide-animation-slideInBottom .bundle-content-slider--slide-inner {
                    opacity: 0;
                    transform: translateY(100%);
                    transition: all .6s ease-out .5s;
                }
                .bundle-content-slider--slide.is-selected.bundle-slide-animation-slideInBottom  .bundle-content-slider--slide-inner {
                    opacity: 1;
                    transform: translateY(0);
                }

                .bundle-slide-animation-slideInLeft .bundle-content-slider--slide-inner {
                    opacity: 0;
                    transform: translateX(-100%);
                    transition: all .6s ease-out .5s;
                }
                .bundle-content-slider--slide.is-selected.bundle-slide-animation-slideInLeft  .bundle-content-slider--slide-inner {
                    opacity: 1;
                    transform: translateX(0);
                }

                .bundle-slide-animation-slideInRight .bundle-content-slider--slide-inner {
                    opacity: 0;
                    transform: translateX(100%);
                    transition: all .6s ease-out .5s;
                }
                .bundle-content-slider--slide.is-selected.bundle-slide-animation-slideInRight  .bundle-content-slider--slide-inner {
                    opacity: 1;
                    transform: translateX(0);
                }

                .bundle-content-slider .flickity-page-dots {
                    text-align: center;
                    width: 100%;
                    padding: 0;
                    margin: 0;
                    padding: 10px 0;
                    position: static;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-page-dots {
                    position: {{settingsFromWeebly.settings.dotsPosition === 'bottom' ? 'static;' : 'absolute;'}}
                    {{settingsFromWeebly.settings.dotsPosition === 'top' ? 'bottom: 5px;' : null}}
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-page-dots .dot {
                    width: 12px;
                    height: 12px;
                    opacity: 1;
                    display: inline-block;
                    border-radius: 50%;
                    margin: 0 4px;
                    transition: all .3s ease;
                    vertical-align: middle;
                    padding: 0;
                    font-size: 0;
                    cursor: pointer;
                    transform: scale(.8);
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-page-dots .dot {
                    background: {{settingsFromWeebly.settings.dotAccentColor}};
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-page-dots .dot.is-selected,
                .bundle-content-slider .flickity-page-dots .dot:hover {
                    border: 1px solid {{settingsFromWeebly.settings.dotAccentColor}};
                    background: #fff;
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-page-dots .dot.is-selected {
                    transform: scale(1.2)
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: {{settingsFromWeebly.settings.arrowSize}}px;
                    height: {{settingsFromWeebly.settings.arrowSize}}px;
                    border-radius: {{settingsFromWeebly.settings.arrowRadius}}px;
                    background: {{settingsFromWeebly.settings.arrowBg}};
                    border: 0;
                    text-align: center;
                    padding: 0;
                    opacity: 0;
                    transition: all .3s ease-out;
                    outline: none!important;
                    {{!settingsFromWeebly.settings.arrows ? 'display: none;': null}}
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button.previous {
                    left: -5px;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button.next {
                    right: -5px;
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider:hover .flickity-button.flickity-prev-next-button {
                    opacity: 1;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider:hover .flickity-button.flickity-prev-next-button.next {
                    right: 5px;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider:hover .flickity-button.flickity-prev-next-button.previous {
                    left: 5px;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button:hover {
                    background: {{settingsFromWeebly.settings.arrowBgHover}};
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button[disabled]{
                    opacity: 0;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button-icon {
                    fill: {{settingsFromWeebly.settings.arrowColor}};
                    height: {{settingsFromWeebly.settings.arrowSize/2.75}}px;
                    width: auto;
                    position: static;
                }
                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-slider .flickity-button.flickity-prev-next-button:hover .flickity-button-icon {
                    fill: {{settingsFromWeebly.settings.arrowColorHover}};
                }
            </component>

            <component :is="style" v-if="settingsFromWeebly.settings.testimonialStyle === 'style1'">

                .bundle-testimonial-slider {

                }

                .bundle-testimonial-slider-style1 .bundle-quote-body {
                    position: relative;
                    padding-top: 65px;
                }

                .bundle-testimonial-slider-style1 .bundle-quote-body--image {
                    position: absolute;
                    width: 100px;
                    height: 100px;
                    overflow: hidden;
                    top: 0;
                    left: 50%;
                    margin-top: -50px;
                    margin-left:-50px;
                    border-radius: 50%;
                    box-shadow: 0 5px 10px rgba(0,0,0,.15);
                }
                .bundle-testimonial-slider-style1 .bundle-quote-body--image .wsite-image {
                    margin: 0!important;
                    padding: 0!important;
                }
                .bundle-testimonial-slider-style1 .bundle-quote-body--image .wsite-image img, .bundle-testimonial-slider-style1 .bundle-quote-body--image  img{
                    max-height: 100px;
                    min-height: 100px;
                    width: auto;
                    max-width: none!important;
                } 
                .bundle-testimonial-slider-style1 .bundle-quote-body--stars {
                    text-align: center;
                    margin: 15px auto;
                }
                .bundle-testimonial-slider-style1 .bundle-quote-body--stars i {
                    font-size: 12px;
                    color: {{settingsFromWeebly.settings.starColor}};
                }
                .bundle-testimonial-slider-style1 .bundle-quote-body--quote {
                    margin: 15px 0;
                    padding: 15px 0;
                    position: relative;
                }
                .bundle-testimonial-slider-style1.bundle-testimonial-slider:before {
                    content: "\f10d";
                    font-family: "Font Awesome 5 Free";
                    font-weight: 900;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                    display: inline-block;
                    font-style: normal;
                    font-variant: normal;
                    text-rendering: auto;
                    line-height: 1;
                    font-size: 25px;
                    position: absolute;
                    left: 10px;
                    top: 50px;
                    z-index: 2;
                    color: {{settingsFromWeebly.settings.quotesColor}};
                }
                .bundle-testimonial-slider-style1.bundle-testimonial-slider:after {
                    content: "\f10e";
                    font-family: "Font Awesome 5 Free";
                    font-weight: 900;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                    display: inline-block;
                    font-style: normal;
                    font-variant: normal;
                    text-rendering: auto;
                    line-height: 1;
                    font-size: 25px;
                    position: absolute;
                    right: 10px;
                    bottom: 50px;
                    z-index: 2;
                    color: {{settingsFromWeebly.settings.quotesColor}};
                }
                .bundle-testimonial-slider-style1 .bundle-quote-body--name {
                    margin-top: 15px;
                }
            </component>

            <component :is="style" v-if="settingsFromWeebly.settings.testimonialStyle === 'style2'">

                .bundle-testimonial-slider {

                }

                .bundle-testimonial-slider-style2 .bundle-quote-body {
                    position: relative;
                    padding-top: 65px;
                    display: flex;
                    align-items: center;
                }

                .bundle-testimonial-slider-style2 .bundle-quote-body-left {
                    width: 300px;
                    text-align: center;
                    border-right: 1px solid #ccc;
                    padding-right: 10px;
                }

                #bundle-content-slider-{{globalSettings.elementIdWeebly}}.bundle-testimonial-slider-style2 .bundle-quote-body-left {
                    border-color: {{settingsFromWeebly.settings.style2BorderSeparator}};
                }

                .bundle-testimonial-slider-style2 .bundle-quote-body-right {
                    padding-left: 10px;
                    text-align: center;
                    flex: 1;
                }

                .bundle-testimonial-slider-style2 .bundle-quote-body--image {
                    width: 100px;
                    height: 100px;
                    overflow: hidden;
                    border-radius: 50%;
                    box-shadow: 0 5px 10px rgba(0,0,0,.15);
                    margin: 0 auto;
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--image .wsite-image {
                    margin: 0!important;
                    padding: 0!important;
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--image .wsite-image img, .bundle-testimonial-slider-style2 .bundle-quote-body--image  img{
                    max-height: 100px;
                    min-height: 100px;
                    width: auto;
                    max-width: none!important;
                    display: block;
                } 
                .bundle-testimonial-slider-style2 .bundle-quote-body--stars {
                    text-align: center;
                    margin: 15px auto;
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--stars i {
                    font-size: 12px;
                    color: {{settingsFromWeebly.settings.starColor}};
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--quote {
                    margin: 15px 0;
                    padding: 15px 0;
                    position: relative;
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--quote:before {
                    content: "\f10d";
                    font-family: "Font Awesome 5 Free";
                    font-weight: 900;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                    display: inline-block;
                    font-style: normal;
                    font-variant: normal;
                    text-rendering: auto;
                    line-height: 1;
                    font-size: 25px;
                    position: absolute;
                    left: 10px;
                    top: -17px;
                    z-index: 2;
                    color: {{settingsFromWeebly.settings.quotesColor}};
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--quote:after {
                    content: "\f10e";
                    font-family: "Font Awesome 5 Free";
                    font-weight: 900;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                    display: inline-block;
                    font-style: normal;
                    font-variant: normal;
                    text-rendering: auto;
                    line-height: 1;
                    font-size: 25px;
                    position: absolute;
                    right: 10px;
                    bottom: -17px;
                    z-index: 2;
                    color: {{settingsFromWeebly.settings.quotesColor}};
                }
                .bundle-testimonial-slider-style2 .bundle-quote-body--name {
                    margin-top: 15px;
                }
            </component>

            <component :is="style" v-for="(slide, index) in slidesArray" :key="index">
                #{{slide.slideId}}.bundle-content-slider--slide {
                    padding: 60px 0 30px;
                }
                #{{slide.slideId}}.bundle-content-slider--slide .bundle-quote-body{

                    {{slide.backgroundColorChild ? 'background: '+slide.childBackground+';':''}}
                    {{slide.backgroundImageChild ? 'background: url('+slide.backgroundImageChildSet+')'+' '+ slide.xAxisPosition+' '+slide.yAxisPosition+'/cover;':''}}

                    padding: {{slide.verticalPad}}px {{slide.horizontalPad}}px;
                    
                    {{ slide.useIndividualBorder ?
                    'border-top-color:' + slide.borderTopColor+';' 
                    +'border-top-style:' + slide.borderTopStyle +';'
                    +'border-top-width:' + slide.borderTopWidth +'px;'

                    +'border-right-color:' + slide.borderRightColor +';'
                    +'border-right-style:' + slide.borderRightStyle +';'
                    +'border-right-width:' + slide.borderRightWidth+'px;'

                    +'border-bottom-color:'+ slide.borderBottomColor +';'
                    +'border-bottom-style: '+slide.borderBottomStyle+';'
                    +'border-bottom-width:' +slide.borderBottomWidth+'px;'

                    +'border-left-color:' +slide.borderLeftColor+';'
                    +'border-left-style:' +slide.borderLeftStyle+';'
                    +'border-left-width:' +slide.borderLeftWidth+'px;'
                    : ''}}

                    {{ !slide.useIndividualBorder ? 'border:' + slide.borderGeneralWidth+'px ' + slide.borderGeneralStyle+' ' + slide.borderGeneralColor+';' : '' }}

                    {{!slide.useIndividualBorderRadius ? 'border-radius:'+slide.borderRadiusGeneral+'px;' : ''}}

                    {{ slide.useIndividualBorderRadius ?
                    'border-top-left-radius:' + slide.borderTopLeftRadius+'px;' 
                    +'border-top-right-radius:' + slide.borderTopRightRadius+'px;'
                    +'border-bottom-right-radius:' + slide.borderBottomRightRadius+'px;'
                    +'border-bottom-left-radius:' + slide.borderBottomLeftRadius+'px;'
                    : ''}}
                    

                }  
                
                

            </component>


        </div>

        <div class="loading-overlay" v-if="creatingSlide">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Creating new slide
                </div>
            </div>
                
        </div>

        <div class="loading-overlay" v-if="loadingSlider">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Loading slider
                </div>
            </div>
                
        </div>

    </div>

</template>

<script>

import TestimonialSliderSlide from './elementSettings/contentsliderslide/TestimonialSliderSlide'
import draggable from 'vuedraggable'

export default {

    name: 'TestimonialSlider',

    data () {

        return {
            style: 'style',
            script: 'script',
            creatingSlide: false,
            loadingSlider: true
        }
    },

    components: {
        draggable,
        TestimonialSliderSlide,

        'vscript': {
            render: function (createElement) {

                return createElement('script', this.$slots.default)
                
            }
        }
    },

    methods: {

        flickityStart: function() {
            setTimeout(()=> {
                // settings
                var wrapAround = this.$store.state.weeblySettings.settings.loop == 'true' || this.$store.state.weeblySettings.settings.loop == true ? true : false
                var autoplay = this.$store.state.weeblySettings.settings.autoplay
                var autoplayspeed = this.$store.state.weeblySettings.settings.autoplaySpeed
                console.log('autoplay: ',autoplay + ' '+ 'autospeed ',autoplayspeed)

                var flkty = new Flickity( '.bundle-content-slider', {
                    wrapAround: wrapAround,
                    autoPlay: autoplay ? autoplayspeed : false
                });
            },500)
        },

        reloadFlickity() {
            this.$store.state.weeblySettings.settings.slideReordering = false
            document.querySelector('.preview-box').classList.remove('slides-modifying');
            console.log('we added a new slide');
            // create it to destroy it
            var flkty = new Flickity( '.bundle-content-slider');
            // destroy it
            flkty.destroy();

            this.flickityStart()

        },

        reOrderSlides() {
            // create it to destroy it
            var flkty = new Flickity( '.bundle-content-slider');
            // destroy it
            flkty.destroy();
            // var slides = this.$store.state.weeblySettings.settings.slides;
            this.$store.state.weeblySettings.settings.slides.forEach(slide => {
                console.log('id of slide ',slide.slideId)
            });
            this.$store.state.weeblySettings.settings.slideReordering = true
            document.querySelector('.preview-box').classList.add('slides-modifying');
            
        },

        addToChildArray() {
            this.creatingSlide = true
            // document.querySelector( '.bundle-content-slider').style.opacity = 0;
            this.reOrderSlides()

            this.$store.state.weeblySettings.settings.slides.push(
                {
                    slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
                    childBackground: '#f1f1f1',
                    horizontalPad: 50,
                    verticalPad: 50,

                    borderGeneralColor: '#cccccc',
                    borderGeneralStyle: 'solid',
                    borderGeneralWidth: 0,

                    useIndividualBorder: false,

                    borderTopColor: '#cccccc',
                    borderTopStyle: 'solid',
                    borderTopWidth: 1,
                    
                    borderRightColor: '#cccccc',
                    borderRightStyle: 'solid',
                    borderRightWidth: 1,
                    
                    borderBottomColor: '#cccccc',
                    borderBottomStyle: 'solid',
                    borderBottomWidth: 1,
                    
                    borderLeftColor: '#cccccc',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,

                    useIndividualBorderRadius: false,

                    borderRadiusGeneral: 0,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,

                    backgroundColorChild: true,
                    backgroundImageChild: false,
                    backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',

                    xAxisPosition: 'center',
                    yAxisPosition: 'center',
                    slideAnimation: false,
                    animationClass: 'bundle-slide-animation-slideInTop',

                    starAmount: 5
                }
            )

            setTimeout( ()=> {
                // this.reloadFlickity();
                // document.querySelector( '.bundle-content-slider').style.opacity = 1;
                this.creatingSlide = false
            },1200)
            

        }

    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // get array of titles
        slidesArray: {
            get() {
                return this.$store.state.weeblySettings.settings.slides
            },
            set(value) {
                console.log(value)
                // this.$store.commit('updateList', value)
                return this.$store.state.weeblySettings.settings.slides = value
            }
        }

    },
    
    mounted() {
        console.log('content slider', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active');

        // 
        setTimeout(()=> {
            this.flickityStart()
            this.loadingSlider = false
        }, 2000)



    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.preview-box  {
    display: block;
}

.slides-modifying {
    .bundle-content-slider.bundle-slider {
        overflow: visible;

        .bundle-content-slider--slide {
            margin: 10px auto;
        }
    }
    .bundle-content-slider--slide {
        overflow: visible!important;
    }
}

.slider-actions {

    list-style: none;
    margin: 0;
    padding: 0;
    margin-bottom: 30px;

    li {
        padding: 0px 15px;
        height: 31px;
        line-height: 31px;
        display: inline-block;
        border: 1px solid @border_grey_medium;
        cursor: pointer;
        border-radius: .25rem;
        background: #fff;
        font-size: 12px;
        font-weight: 700;
        text-transform: capitalize;
        margin: 7px 7px 7px 0;

        &.add-slide-btn {
            font-weight: 700;
            width: 50px;
            height: 50px;
            line-height: 50px;
            border-radius: 50%;
            padding: 0;
            margin: 0;
            font-size: 20px;
            -webkit-box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
            box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
            -webkit-transition: all 0.3s ease-out;
            transition: all 0.3s ease-out;
            background: #4CC195;
            border: 0;
            text-align: center;
            color: #fff;
            margin-right: 7px;

            &:hover {
                -webkit-transform: translateY(-4px);
                transform: translateY(-4px);
                -webkit-box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
                box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
                background: rgba(76, 193, 149, 0.9);
            }
        }
        
    }

}

.testimonialslider-selection-style {
    list-style: none;
    text-align: center;
    li {
        display: inline-block;
        padding: 15px 30px;
        margin: 7px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: .25rem;
        cursor: pointer;

        &.active {
            border-color: blue;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/elements/TestimonialSlider.vue